import styled from '@emotion/styled'

export default styled.div`
  width: 80%;
  min-width: 376px;
  max-width: 800px;
  margin: 0 auto;
`
